import { ButtonBase, styled } from "@mui/material";

export const FlatRowTriggerButton = styled(ButtonBase)(({ theme }) => ({
	width: "100%",
	minHeight: 48,
	paddingInline: theme.spacing(theme.spacingTokens.lg),
	paddingBlock: theme.spacing(1.4),
	justifyContent: "space-between",
	alignItems: "flex-start",
	"&:active": { backgroundColor: theme.palette.grey[50] },
}));
